import React from "react";
import { object } from "prop-types";
import { Link } from "@quintype/components";

import Headline from "../../atoms/headline";
import CardImage from "../../atoms/card-image";

import "./project-story-header.m.css";

const ProjectStoryHeader = ({ story }) => {
  const sectionName = story.sections[0]["display-name"] || story.sections[0].name;
  const sectionSlug = story.sections[0]["slug"] || "";

  return (
    <div styleName="header-content">
      <Link href={`/${sectionSlug}`}>
        <Headline text={sectionName} headerType={9} headerLevel={2} />
      </Link>

      <Headline text={story.headline} headerType={1} headerLevel={2} />
      <CardImage story={story} defaultWidth={36} aspectRatio={[16, 9]} imageType="image16x9" />

      <div styleName="figure-caption">
        {story["hero-image-attribution"] && (
          <span styleName="image-attribute"> {story["hero-image-attribution"]} </span>
        )}
      </div>
    </div>
  );
};

ProjectStoryHeader.propTypes = {
  story: object
};

export default ProjectStoryHeader;
